import type { UnidadeItemGateway } from '@/application/port/out/UnidadeItemGateway';
import type {
  CreateUnidadeItemCommand, CreateUnidadeItemDaBibliotecaCommand,
  CreateUnidadeItemPdfCommand, UnidadeItem,
} from '@/domain/model/UnidadeItem';

export class ListUnidadeItens {
  constructor(private readonly g: UnidadeItemGateway) {}
  execute(unidadeId: string): Promise<UnidadeItem[]> { return this.g.list(unidadeId); }
}
export class CreateUnidadeItem {
  constructor(private readonly g: UnidadeItemGateway) {}
  execute(unidadeId: string, cmd: CreateUnidadeItemCommand): Promise<UnidadeItem> { return this.g.create(unidadeId, cmd); }
}
export class CreateUnidadeItemPdf {
  constructor(private readonly g: UnidadeItemGateway) {}
  execute(unidadeId: string, cmd: CreateUnidadeItemPdfCommand): Promise<UnidadeItem> { return this.g.createPdf(unidadeId, cmd); }
}
export class CreateUnidadeItemDaBiblioteca {
  constructor(private readonly g: UnidadeItemGateway) {}
  execute(unidadeId: string, cmd: CreateUnidadeItemDaBibliotecaCommand): Promise<UnidadeItem> {
    return this.g.createDaBiblioteca(unidadeId, cmd);
  }
}
export class ArquivarUnidadeItem {
  constructor(private readonly g: UnidadeItemGateway) {}
  execute(unidadeId: string, itemId: string): Promise<void> { return this.g.arquivar(unidadeId, itemId); }
}
export class ReordenarUnidadeItens {
  constructor(private readonly g: UnidadeItemGateway) {}
  execute(unidadeId: string, idsNaOrdem: string[]): Promise<void> { return this.g.reordenar(unidadeId, idsNaOrdem); }
}
export class BaixarUnidadeItem {
  constructor(private readonly g: UnidadeItemGateway) {}
  execute(unidadeId: string, itemId: string): Promise<Blob> { return this.g.baixar(unidadeId, itemId); }
}
